module.exports = __webpack_public_path__ + "assets/svg/Icons/32/groups-blue-9f6f71.svg";